function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "18.849"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2147",
  "data-name": "Rectangle 2147",
  fill: "none",
  d: "M0 0h20v18.849H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4988",
  "data-name": "Group 4988"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4987",
  "data-name": "Group 4987",
  transform: "translate(0 .001)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2796",
  "data-name": "Path 2796",
  d: "M11.075 17.263l6.662-6.663a3.789 3.789 0 000-5.358L13.6 1.11a3.786 3.786 0 00-5.357 0L1.107 8.249a3.793 3.793 0 000 5.356l4.135 4.135a3.751 3.751 0 002.381 1.081v.029H20v-1.587zM9.368 2.232a2.253 2.253 0 013.112 0l4.135 4.134a2.2 2.2 0 010 3.113l-3.009 3.008L6.36 5.241zM2.229 12.483a2.2 2.2 0 010-3.112l3.008-3.008 7.247 7.248-3.008 3.007a2.253 2.253 0 01-3.112 0z",
  fill: "#fff"
})))));